import api from './api';

export const listarCursos = async () => {
  try {
    const response = await api.get('/cursos', {
      params: {
        include: 'campanha'
      }
    });
    console.log('Resposta listarCursos:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro em listarCursos:', error);
    throw error;
  }
};

export const obterCurso = async (id) => {
  try {
    const response = await api.get(`/cursos/${id}`);
    console.log(`Resposta obterCurso (${id}):`, response.data); // Log para verificar resposta
    return response.data;
  } catch (error) {
    console.error(`Erro em obterCurso (${id}):`, error);
    throw error;
  }
};

export const criarCurso = async (cursoData) => {
  try {
    const response = await api.post('/cursos', cursoData);
    console.log('Resposta criarCurso:', response.data); // Log para verificar resposta
    return response.data;
  } catch (error) {
    console.error('Erro em criarCurso:', error);
    throw error;
  }
};

export const atualizarCurso = async (id, cursoData) => {
  try {
    const response = await api.put(`/cursos/${id}`, cursoData);
    console.log(`Resposta atualizarCurso (${id}):`, response.data); // Log para verificar resposta
    return response.data;
  } catch (error) {
    console.error(`Erro em atualizarCurso (${id}):`, error);
    throw error;
  }
};

export const excluirCurso = async (id) => {
  try {
    const response = await api.delete(`/cursos/${id}`);
    console.log(`Resposta excluirCurso (${id}):`, response.data); // Log para verificar resposta
    return response.data;
  } catch (error) {
    console.error(`Erro em excluirCurso (${id}):`, error);
    throw error;
  }
};
